// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2nPu_","loaderOuter":"PageOverlayLoader_loaderOuter__2nE-U"};